"use strict";
exports.__esModule = true;
exports.toCTASlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var toCTASlice = function (data, logger) {
    return utils_1.compact({
        type: types_1.SliceType.Cta,
        cta: logger.required(field_groups_1.toCta(data.primary, logger))
    });
};
exports.toCTASlice = toCTASlice;
//# sourceMappingURL=cta-slice.js.map